"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeApiClient = void 0;
const types_1 = require("../../../types");
const metricTypeMap = {
    [types_1.CustomMetricType.COUNT]: 'count',
    [types_1.CustomMetricType.RATE]: 'rate',
    [types_1.CustomMetricType.GAUGE]: 'gauge',
    [types_1.CustomMetricType.DISTRIBUTION]: 'distribution',
};
function mapMetricsToPayload(metrics) {
    const series = metrics.map(({ name, value, type, tags, timestamp }) => ({
        metric: name,
        type: metricTypeMap[type],
        tags,
        points: [[timestamp / 1000, value]],
    }));
    return { series };
}
function makeApiClient({ proxyUrl }) {
    return {
        send(metrics) {
            return __awaiter(this, void 0, void 0, function* () {
                const payload = mapMetricsToPayload(metrics);
                const response = yield fetch(proxyUrl, {
                    method: 'POST',
                    body: JSON.stringify(payload),
                });
                if (response.status >= 400) {
                    throw new Error(`Network error (status: ${response.status})`);
                }
            });
        },
    };
}
exports.makeApiClient = makeApiClient;
//# sourceMappingURL=api-client.js.map